import { render, staticRenderFns } from "./TransverseTable.vue?vue&type=template&id=a3c349f4&"
import script from "./TransverseTable.vue?vue&type=script&lang=js&"
export * from "./TransverseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports